<template>
  <page-wrapper :title="title" ref="pageEl">
    <div class="header">
      <div class="container">
        <div class="row mb-3">
          <div class="col-lg-3 mb-3">
            <label>ชื่อโครงการ</label>
            <el-input v-model="query.name"></el-input>
          </div>
          <div class="col-lg-3 mb-3">
            <label>รหัสโครงการ</label>
            <el-input v-model="query.code"></el-input>
          </div>
          <div class="col-lg-3 mb-3">
            <label>ประเภทโครงการ</label>
            <el-select class="w-100" v-model="query.type" clearable>
              <el-option
                v-for="t in projectTypes"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </div>
          <div class="col-lg-3 mb-3">
            <label>สถานะโครงการ</label>
            <el-select class="w-100" v-model="query.status" clearable>
              <el-option
                v-for="t in projectStatuses"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="mt-3 text-right">
          <sc-button variant="secondary" @click="handleClickSearchButton"
            >ค้นหา</sc-button
          >
        </div>
      </div>
    </div>
    <div class="container">
      <p class="mb-2 mt-2" v-if="list.length">{{ totalCount }}</p>
      <div class="project-list-item" v-for="item in list">
        <img :src="item.logoUrl" class="logo" />
        <div class="meta">
          <div class="title">
            <router-link :to="item.route" class="name">{{
              item.name
            }}</router-link>
            <div class="code">{{ item.code }}</div>
          </div>
          <div class="location">{{ item.location }}</div>
          <div class="type">{{ item.type }}</div>
        </div>
      </div>
      <br />
      <div class="text-right">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :size="10"
          :current-page="query.page"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import {
  Pagination,
  Input,
  Checkbox,
  CheckboxGroup,
  Select,
  Option
} from "element-ui";
import ScButton from "@/lib/components/ScButton";
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    ScButton,
    "el-input": Input,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option
  },
  data() {
    const title = "รายการโครงการ";
    const total = 100;
    const query = { name: null, code: null, type: null, status: null, page: 1 };

    const projectStatuses = [
      "ready_to_sale",
      "on_sale",
      "sale_transfer",
      "transfer"
    ].map(v => ({ label: v, value: v }));
    const projectTypes = [
      { label: "แนวราบ", value: "L" },
      { label: "แนวสูง", value: "H" }
    ];

    return {
      title,
      list: [],
      total,
      query,
      projectStatuses,
      projectTypes
    };
  },
  computed: {
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page;
      const end = (isLastPage ? total : currentPage * limit).toLocaleString();
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    }
  },
  created() {
    this.setup();
  },
  watch: {
    async "$route.query"(query) {
      this.setupQuery();
      await this.setupData();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    }
  },
  methods: {
    async setup() {
      this.setupQuery();
      await this.setupData();
    },
    async setupQuery() {
      this.query = {
        name: this.$route.query.name || null,
        code: this.$route.query.code || null,
        type: this.$route.query.type || null,
        status: this.$route.query.status || null,
        page: this.$route.query.page || 1
      };
    },
    async setupData() {
      const { total, data } = await this.fetchData();
      const projectType = {
        L: "แนวราบ",
        H: "แนวสูง"
      };

      this.total = total;
      this.list = data.map(project => {
        return {
          id: project.project_id,
          code: project.project_code,
          name: project.project_name,
          logoUrl: project.project_icon,
          location: project.project_location,
          type: projectType[project.project_type],
          route: {
            name: "ProjectDetailPage",
            params: { id: project.project_id }
          }
        };
      });
    },
    async fetchData() {
      const response = await baanRueJaiClient.admin.projects.search(this.query);

      return response.data.result;
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    handleClickSearchButton() {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, ...this.query }
      };
      this.$router.replace(route);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: $space 0;
  background: #fafafa;
  border-bottom: $border;
}

.project-list-item {
  display: grid;
  grid-template-columns: 64px 1fr;
  grid-gap: 30px;
  border-bottom: $border;
  padding: 15px 0;

  > .logo {
    width: 64px;
    margin-top: 4px;
  }

  .meta {
    line-height: 1.6;
  }

  .code {
    text-align: right;
  }

  .title {
    display: grid;
    grid-template-columns: 1fr 120px;
    font-size: 16px;
  }

  .name {
    font-weight: bold;
  }

  .location,
  .type {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/projects/pages/ProjectListPage.vue